/**
 * Audit Log Types - TypeScript Definitions for Audit Logs
 */

// Audit Log Action enum
export enum AuditLogAction {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  ACTIVATED = 'ACTIVATED',
  INACTIVATED = 'INACTIVATED',
  PAUSED = 'PAUSED',
  DELETED = 'DELETED',
  EXPIRED = 'EXPIRED',
}

// Audit Log Change interface
export interface AuditLogChange {
  field: string;
  label: string;
  newValue: any;
  oldValue: any;
}

// Audit Log interface
export interface AuditLog {
  _id: string;
  action: AuditLogAction;
  changedBy: string | null;
  changes: AuditLogChange;
  promoName?: string;
  timestamp: string;
}

// Audit Log List Parameters
export interface AuditLogListParams {
  pageNum?: number;
  pageSize?: number;
  promoId?: string;
  campaignId?: string; // Filter by campaign ID
  action?: AuditLogAction;
  promoName?: string;
  startAt?: string; // Date string in YYYY-MM-DD format
  endAt?: string; // Date string in YYYY-MM-DD format
}

// Audit Log List Response
export interface AuditLogListResponse {
  results: AuditLog[];
  totalCount: number;
}
